module.exports = __webpack_public_path__ + "svg_80x80/clojure.3ab1e0.svg";